import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AdaptiveAccessChart, AdaptiveAccessDashboard, AssetManagement } from "@aptsi-types";
import { environment } from "@env";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { ErrorHandlingService } from "../shared/errorHandling/errorHandling.service";
import { API_ENDPOINTS } from "../ada-access-api-endpoints";

// interface GetAssetMangementsResponse {
//   assetmanagementdashboard: AssetManagement[];
// }

interface GetAdaptiveAccessResponse {
    adaptiveaccessdashboard: AdaptiveAccessDashboard;
}

interface GetAdaptiveAccessChartResponse {
    adaptiveaccesscharts: AdaptiveAccessChart[];
}

@Injectable({
  providedIn: "root",
})
export class AdaptiveaccessDashboardService {
  private readonly adaptiveaccessreportsUrl = environment.apiUrl;

  constructor(
    private http: HttpClient,
    private errorHandlingService: ErrorHandlingService
  ) {}
  
  getAcDashboardData(): Observable<AdaptiveAccessDashboard> {
    return this.http
      .post<GetAdaptiveAccessResponse>(
        `${this.adaptiveaccessreportsUrl}${API_ENDPOINTS.DASHBOARD.FETCH}`,
        { }
      )
      .pipe(
        map((response) => response.adaptiveaccessdashboard),
        catchError((error) => this.errorHandlingService.handleError(error))
      );
  }

  getAcDashboardChartData(selectedFilter: string): Observable<AdaptiveAccessChart[]> {
    return this.http
      .post<GetAdaptiveAccessChartResponse>(
        `${this.adaptiveaccessreportsUrl}${API_ENDPOINTS.DASHBOARD.FETCHCHARTDATA}`,
        { selectedFilter }
      )
      .pipe(
        map((response) => response.adaptiveaccesscharts),
        catchError((error) => this.errorHandlingService.handleError(error))
      );
  }

}
